import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import MedicalEquipmentsServices from "../views/MedicalEquipmentsServices";
import PromotionalMaterialServices from "../views/PromotionalMaterialServices";
import EducationalSolutionsServices from "../views/EducationalSolutionsServices";
import SmartMobileServices from "../views/SmartMobileServices";
import RealEstateServices from "../views/RealEstateServices";
import TelecomServices from "../views/TelecomServices";
import IctServices from "../views/IctServices";
import AgriculturalServices from "../views/AgriculturalServices";
import RenewwableEnergyServices from "../views/RenewwableEnergyServices";
import GreenEnergyServices from "../views/GreenEnergyServices";
import LogisticsServices from "../views/LogisticsServices";

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'medical_equipments' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MedicalEquipmentsServices/>
		} else if(
			appContext.navSubItem === 'promotional_materials' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <PromotionalMaterialServices/>
		} else if(
			appContext.navSubItem === 'educational_solutions' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <EducationalSolutionsServices/>
		} else if(
			appContext.navSubItem === 'smart_mobile' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <SmartMobileServices/>
		} else if(
			appContext.navSubItem === 'real_estate' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <RealEstateServices/>
		} else if(
			appContext.navSubItem === 'telecom_solutions' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <TelecomServices/>
		} else if(
			appContext.navSubItem === 'ict_solutions' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IctServices/>
		} else if(
			appContext.navSubItem === 'agricultular_solutions' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <AgriculturalServices/>
		} else if(
			appContext.navSubItem === 'energy_solutions' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <RenewwableEnergyServices/>
		} else if(
			appContext.navSubItem === 'green_energy' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <GreenEnergyServices/>
		} else if(
			appContext.navSubItem === 'logistics' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <LogisticsServices/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}